export enum FACTURA_EXPORTACION_TYPES {
    FE_SET_VIEW = 'FE_SET_VIEW',
    FE_SET_FORM_CLIENTE = 'FE_SET_FORM_CLIENTE',
    FE_HANDLE_ERRORS_CLIENTE = 'FE_HANDLE_ERRORS_CLIENTE',
    FE_SET_FORM_PRODUCTO = 'FE_SET_FORM_PRODUCTO',
    FE_HANDLE_ERRORS_PRODUCTO = 'FE_HANDLE_ERRORS_PRODUCTO',
    FE_SET_PRODUCTOS = 'FE_SET_PRODUCTOS',
    FE_SET_PRODUCTO_EDIT = 'FE_SET_PRODUCTO_EDIT',
    FE_SET_PRODUCTO_INDEX = 'FE_SET_PRODUCTO_INDEX',

    FE_ACTIVE_MODAL_EDITAR_PRODUCTO = 'FE_ACTIVE_MODAL_EDITAR_PRODUCTO',
    FE_ACTIVE_MODAL_ELIMINAR_PRODUCTO = 'FE_ACTIVE_MODAL_ELIMINAR_PRODUCTO',
    FE_ACTIVE_MODAL_QUITAR_TODO = 'FE_ACTIVE_MODAL_QUITAR_TODO',
    FE_ACTIVE_MODAL_EMITIR = 'FE_ACTIVE_MODAL_EMITIR',
    FE_ACTIVE_MODAL_EMITIDO = 'FE_ACTIVE_MODAL_EMITIDO',
    FE_ACTIVE_MODAL_MAS_OPCIONES = 'FE_ACTIVE_MODAL_MAS_OPCIONES',
    FE_ACTIVE_MODAL_ENVIAR_CORREO = 'FE_ACTIVE_MODAL_ENVIAR_CORREO',
    FE_ACTIVE_MODAL_IMPRIMIR = 'FE_ACTIVE_MODAL_IMPRIMIR',
    FE_ACTIVE_MODAL_ANULAR = 'FE_ACTIVE_MODAL_ANULAR',
    FE_ACTIVE_MODAL_ANULADO = 'FE_ACTIVE_MODAL_ANULADO',

    FE_SET_QR_CODE = 'FE_SET_QR_CODE',
    FE_SET_RESPONSE_EMITIR = 'FE_SET_RESPONSE_EMITIR',

    FE_SET_CALCULOS_PRODUCTO = 'FE_SET_CALCULOS_PRODUCTO',
    FE_SET_CALCULOS_GENERALES = 'FE_SET_CALCULOS_GENERALES',

    FE_RESTART_FORM_PRODUCTO = 'FE_RESTART_FORM_PRODUCTO',
    FE_RESTART_ALL = 'FE_RESTART_ALL',
    FE_SET_CLIENTE_ENCONTRADO = 'FE_SET_CLIENTE_ENCONTRADO',
    FE_ACTIVE_MODAL_CLIENTE_ENCONTRADO = 'FE_ACTIVE_MODAL_CLIENTE_ENCONTRADO',

    FE_SET_RECINTOS = 'FE_SET_RECINTOS',
    FE_SET_REGIMENES = 'FE_SET_REGIMENES',
    FE_SET_INCOTERMS = 'FE_SET_INCOTERMS',
    FE_SET_FORMAS_PAGO = 'FE_SET_FORMAS_PAGO', 
    FE_SET_PAISES = 'FE_SET_PAISES',
    FE_SET_UNIDADES = 'FE_SET_UNIDADES',
    FE_SET_BLOCKED_DATA = 'FE_SET_BLOCKED_DATA',
    FE_SET_TABLE_PRODUCTOS = 'FE_SET_TABLE_PRODUCTOS',
    FE_FORMOBSERVACIONES_HANDLE_CHANGE = 'FE_FORMOBSERVACIONES_HANDLE_CHANGE',
    FE_SET_DOCS_RELACIONADOS = 'FE_SET_DOCS_RELACIONADOS',
}
